<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="900px"
    transition="dialog-transition"
  >
    <template #activator="{}">
      <v-btn
        @click="OnopenEdit"
        :loading="isloading"
        color="success"
        class="ml-2"
        small
        icon
      >
        <v-icon>fas fa-tasks</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        <small class="error--text"
          >Will delete all Cash payed to this transaction.</small
        >
        <v-spacer></v-spacer>

        {{ `${SellType && SellType.toUpperCase()} CART LIST` }}
        <!-- <v-spacer></v-spacer> -->
        <v-btn class="ml-5" icon color="black" @click="closeView">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :mobile-breakpoint="200"
          :headers="CartHeader"
          :items="items"
          :items-per-page="items.length"
          :item-class="item => SelectFinshed(item)"
        >
          <template #top>
            <v-toolbar
              flat
              dark
              :color="SellType == 'retail' ? 'error' : 'primary'"
            >
              <v-spacer></v-spacer>
              <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
            </v-toolbar>
          </template>
          <template v-slot:[`item.InvName`]="{ item }">
            <BulkQty :RemainQty="RemainQty(item)" :item="item"></BulkQty>
          </template>
          <template v-slot:[`item.qty`]="{ item }">
            <QTY-Inc-Dec
              :item="item"
              :decrease="decrease"
              :increase="increase"
            />
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price.toLocaleString() }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ (item.price * item.qty).toLocaleString() }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <strong class="mr-2"> QTY: {{ TotalQtyInCart }} </strong>
        <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
        <v-spacer></v-spacer>
        <!-- {{ IsChanged }} -->
        <v-btn
          @click="SaveChanges"
          :loading="isloading"
          v-if="items.length && IsChanged"
          color="warning"
          dark
        >
          save changes
        </v-btn>
      </v-card-actions>
      <v-divider v-if="errorMsg"></v-divider>
      <v-card-actions v-if="errorMsg">
        <v-spacer></v-spacer>
        <small class="error--text">{{ errorMsg }}</small>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    OnFinish: { type: Function, default: () => null },
    PrintUrl: { type: String, default: () => "/Reports/sales/print" },
    SaleOrder: {
      type: Object,
      required: true,
    },
  },
  components: {
    BulkQty: () => import("../bulkQty"),
    QTYIncDec: () => import("@/components/util/IncrementDecrement"),
  },
  data() {
    return {
      errorMsg: "",
      isloading: false,
      dialog: false,
      SoldItems: [],
      items: [],
      CartHeader: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
        },
        {
          text: "QTY",
          value: "qty",
        },

        {
          text: "PRICE",
          value: "price",
        },
        {
          text: "Total",
          value: "total",
        },
      ],
    };
  },

  computed: {
    IsChanged() {
      // console.log(this.SaleOrder);
      return this.SoldItems.some(item => {
        // console.log(this.items);
        let { qty, price } = this.items.find(itm => itm._id === item._id) || {
          qty: 0,
          price: 0,
        };
        return item.qty != qty || item.price !== price;
      });
    },
    SellType() {
      return this.items.length && this.items[0].SellType;
    },
    TotalQtyInCart() {
      return this.items.reduce((total, item) => {
        // console.log(item.qty);
        return (total += item.qty);
      }, 0);
    },

    TotalPriceInCart() {
      return this.items.reduce((total, item) => {
        return (total += item.qty * item.price);
      }, 0);
    },
  },
  methods: {
    GetReq(query = null) {
      // console.log(this.SaleOrder);
      if (!query) {
        query = {
          OrderCode: this.SaleOrder.Details,
          Description: this.SaleOrder.Description,
          Ref: this.SaleOrder.Ref,
        };
      }
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.PrintUrl,
        query,
      });
    },
    OnopenEdit() {
      //   console.log(this.UsersToken);
      this.items = [];

      this.isloading = true;
      this.GetReq()
        .then(val => {
          const { items } = val.data;
          // console.log(val.data);
          this.SoldItems = items.map(item => {
            if (item.SellType === "retail")
              return { ...item, qty: Math.abs(item.qty) * item.UnitQty };
            return {
              ...item,
              qty: Math.abs(item.qty),
              _id: `${item._id}-${item.code}`,
            };
          });
          this.items = items.map(item => {
            if (item.SellType === "retail")
              return { ...item, qty: Math.abs(item.qty) * item.UnitQty };
            return {
              ...item,
              qty: Math.abs(item.qty),
              _id: `${item._id}-${item.code}`,
            };
          });

          this.dialog = true;
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
      //   this.myDialog = true;
    },

    closeView() {
      this.dialog = false;
    },
    RemainQty(item, remail) {
      if (remail) {
        let { qty } = this.SoldItems.find(prod => prod._id == item._id);
        return qty - item.qty;
      }
      return this.SoldItems.find(prod => prod._id == item._id);
    },
    SelectFinshed(item) {
      let { qty } = this.SoldItems.find(prod => item._id == prod._id);
      // console.log(qty);
      //   if (this.SellType == "retail") qty = qty * UnitQty;

      const remain = Math.abs(qty) - Math.abs(item.qty);
      //   console.log(qty);
      if (remain == 0) return "yellow darken-2 black--text";
      else if (remain < 0) return "error darken-1 white--text";
      else return "";
    },
    increase(item) {
      //   console.log(this.RemainQty(item, true));
      if (this.RemainQty(item, true) > 0)
        this.items = this.items.map(itm => ({
          ...itm,
          qty: item._id === itm._id ? itm.qty + 1 : itm.qty,
        }));
    },
    decrease(item) {
      if (item.qty > 1)
        this.items = this.items.map(itm => ({
          ...itm,
          qty: item._id === itm._id ? itm.qty - 1 : itm.qty,
        }));
      else this.items = this.items.filter(itm => itm._id !== item._id);
    },
    SaveChanges() {
      this.errorMsg = "";
      // if (this.$refs.withDrowform.validate()) {
      let data = {
        items: this.items,
        Client: this.SaleOrder,
      };
      this.isloading = true;
      this.$store
        .dispatch("UPDATE_ONLY", { url: "/customer/EditItems", data })
        .then(() => {
          // console.log(val);
          this.isloading = false;
          this.OnFinish();
          this.closeView();
        })
        .catch(error => {
          this.isloading = false;
          console.log(error);
          this.errorMsg = error && error.response && error.response.data;
        });
    },
  },
};
</script>
